/*
Sohel 12/23/2022 3075154998 Preprocessor new Ux Changes
Lalitha 12/29/2022 3075154998 Integrated Search API
Sohel 12/30/2022 3075154998 integrated Save and get API
Sohel 12/30/2022 3075154998 Add processor Group API integration
Lalitha 12/30/2022 3075154998 Integrated Deleted API
Sohel 01/02/2022 3075154998 populate Processor Group Code
Sohel 01/06/2022 3075154998 reset Add Preprocessor Data
Sohel 01/07/2022 3075154998 search Table Pass Type payload
kavyareddy 01/10/2023 3075154998 Fixed rename issue
Ashraf 01/13/2023 3075154998 fixed page break issue
Dilip 01/10/2023 3075154998 Added edit icon
Dilip 01/13/2023 3075154998 addded preprocessor name in delete popup
Akhila 01/16/2023 3075154998 rename Label description
Lalitha  01/17/2023 3075154998 renamed delete the popup message
manikanta 01/20/2023 3075154998 removing group code while deleting
Rohini 02/09/2023 3075154998 added classnames and enhancements in the text feilds
Prakash 02/14/2023 3075154998 Reverted New UI Changes
suresh peddavoora 02/22/2023 3075154998 New UI changes fixed

Sohel 02/24/2023 3075154998 change processor Group Table validation popup
Sohel 03/01/2023 3075154998 change processor Group API
Dilip 03/21/2023 3075154998 Fixed label changes.
Dilip 03/24/2023 3075154998 Fixed label changes.
Raghu 03/04/2023 3075154998 added plus icon
Akhila 04/25/2023 3075154998  Added usage and override functionality in transformation group
Akhila 04/25/2023 3075154998 rename the usage dialoge box
Ravi 05/16/2023 3075154998 Fixed page Break issue
Akhila 05/31/2023 3075154998 unsaved changes bug fixed
Ravi 05/31/2023 3075154998  changed delete popup message
Akhila 06/08/2023 3075154998 created date change to date created field and column
Akhila 06/12/2023 3075154998 added role access
*/

import {TablePagination, Grid, Button, makeStyles} from '@material-ui/core';
import React, {createRef, useEffect, useRef, useState} from 'react';
import {tableIcons} from '../../../../../../components/TableIcons';
import GuiTable from '../../../../../../components/FormComponents/GuiTable';
import {defaultRows} from '../../../../../../constants/ReusableTablePagination';
import {tablePageRows} from '../../../../../../constants/ReusableConstants';
import moment from 'moment';
import {useUpdateEffect} from 'react-use';
import {httpPaginationDelete, httpPaginationPost, httpPost} from '../../../../../../util/Rest';
import {useDispatch, useSelector} from 'react-redux';
import {ErrorSnackbar, SuccessSnackbar, WarningSnackbar} from '../../../../../../components/CustomSnackBar';
import DeleteTableRecordPopup from '../../../../../../util/DeleteTableRecordPopup';
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined';
import EditOutlinedIcon from '@material-ui/icons/EditOutlined';
import {
  fetchPrePreprocessorGroupData,
  resetAddPreprocessorGroup,
  fetchPreprocessorGroupUsage,
  resetPreprocessorUsageData,
} from '../../../../../../redux/reducers/DataManagerRecord';
import DialogBox from '../../../../../../components/DialogBox';
import ProcessorGroupValidationPopup from './ProcessorGroupValidationPopup';
import PageLoader from '../../../../../../components/PageLoader';
import AddIcon from '@material-ui/icons/AddOutlined';
import DataUsageIcon from '@material-ui/icons/DataUsage';
import OverrideRule from '../../../../../../components/OverrideRule';
import UsageMessage from '../../../../../../util/UsageMessage';

const useStyles = makeStyles((theme) => ({
  'link': {
    color: '#320469 !important',
    borderBottom: '1px solid #000099',
  },
  ' & .MuiSvgIcon-root': {
    backgroundColor: '#320469 !important',
  },
}));
function ProcessorsGroupTable({
  setShowSearch,
  searchData,
  submit,
  setSubmit,
  setProcessorGroupCode,
  processorGroupCode,
  exportManagerRecord,
  managerRecordGroup = false,
  setPreprocessorUsage,
  useAgeOpen,
  setUsageOpen,
  handleUsageClose,
  handleDirty,
  editExisting,
  dmTempRecordAccess,
  setDmProcessorGroupId=()=>{},
}) {
  const tableRef = createRef();
  const [rows, setRows] = useState(defaultRows);
  const [arrayLast, setArrayLast] = useState(false);
  const [deleteErrorMsg, setDeleteErrorMsg] = useState('');
  const deletedId = useRef(null);
  const validateId = useRef(null);
  const [status, setStatus] = useState(false);
  const dispatch = useDispatch();
  const classes1 = useStyles();
  const [isDelete, setIsDelete] = useState(false);
  const [tstmsg, setToastMsg] = useState('');
  const [processorId, setProcessorId] = useState('');
  const [validate, setValidate] = useState('');
  const [validationSuccess, setValidationSuccess] = useState('');
  const [validationError, setValidationError] = useState('');
  const [loader, setLoader] = useState(false);
  const [deleteUsage, setDeleteUsage] = useState(false);
  const [userMetrixDelete, setUserMetrixDelete] = useState(false);
  const [isUsage, setIsUsage] = useState(false);
  const [customError, setCustomError] = useState(false);

  const {
    recordCode,
    isAddProcessorLoading,
    preProcessorUsageData,
  } = useSelector(({dataManagerRecord}) => dataManagerRecord);
  const {groupCode} = useSelector(({dataManagerRecordGroup}) => dataManagerRecordGroup);
  const type = exportManagerRecord ? 'Export' : 'Import';
  const handleUsage = (rowData) => {
    setDeleteUsage(false);
    setPreprocessorUsage(rowData);
    dispatch(fetchPreprocessorGroupUsage(rowData?.dmProcessorGroupId));
  };

  const columns = [
    {
      title: 'Transformation Group Name',
      field: 'processorGroupCode',
      render: (rowData) => (
        <span
          role="button"
          className={classes1.link}
          onClick={() => {
            handleEdit(rowData);
          }}
        >
          {rowData?.processorGroupCode}
        </span>
      ),
    },
    {
      title: 'Transformation Group Description',
      field: 'processorType',
    },
    {
      title: 'Date Created',
      field: 'createdDate',
      render: (rowData) => {
        return rowData?.createdDate ? moment(rowData?.createdDate).format('MM/DD/YYYY') : '';
      },
    },
  ];
  useEffect(() => {
    if (tableRef?.current && submit) {
      Object.keys(searchData).length > 0 ? tableRef.current.onQueryChange() : '';
    }
  }, [submit]);
  useEffect(() => {
    dispatch(resetAddPreprocessorGroup());
    setCustomError(false)
  }, []);

  useEffect(() => {
    if (tstmsg || deleteErrorMsg) {
      setTimeout(() => {
        setToastMsg('');
        setDeleteErrorMsg('');
      }, 1500);
    }
  }, [tstmsg, deleteErrorMsg]);

  useEffect(() => {
    if (validationSuccess) {
      setTimeout(() => {
        setValidationSuccess('');
      }, 2500);
    }
  }, [validationSuccess]);

  useEffect(() => {
    if (preProcessorUsageData?.userMetrix === 'No') {
      if (deleteUsage) {
        setUserMetrixDelete(false);
        setIsDelete(true);
      } else {
        setCustomError(true)
        setTimeout(() => {
          setCustomError(false)
          dispatch(resetPreprocessorUsageData());
        }, 3000);
      }
    } else if (preProcessorUsageData?.userMetrix === 'Yes') {
      if (deleteUsage) {
        setIsDelete(true);
        setUserMetrixDelete(true);
      } else {
        // setValue(2);
        setUsageOpen(true);
      }
    }
  }, [preProcessorUsageData]);

  const handleClose = () => {
    setIsDelete(false);
  };
  const handleValidationClose = () => {
    setValidationError(false);
    setStatus(true);
    setProcessorGroupCode('');
    setDmProcessorGroupId(0)
  };
  const handleValidateClose = () => {
    setValidate(false);
    setProcessorGroupCode('');
    setDmProcessorGroupId(0)
    setStatus(true);
  };
  useEffect(() => {
    if (tableRef?.current && submit) {
      tableRef.current.onQueryChange();
    }
  }, [processorGroupCode]);
  const handleSubmit = () => {
    httpPaginationDelete(`data-manager/processor/delete/${deletedId.current?.dmProcessorGroupId}`)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setToastMsg(response?.response);
          setIsDelete(false);
          setStatus(true);
          if (deletedId.current?.processorGroupCode === processorGroupCode) {
            setProcessorGroupCode('');
            setDmProcessorGroupId(0)
          }
        } else {
          setDeleteErrorMsg(response?.data?.message);
          setIsDelete(false);
        }
      })
      .catch((error) => {
        console.log(error);
      });
    handleDirty(true);
  };
  const handleDeleteUsage = () => {
    if (isDelete && userMetrixDelete) {
      setIsUsage(true);
      setIsDelete(false);
      setUserMetrixDelete(false);
    } else {
      handleSubmit();
    }
  };
  const handleDelete = (rowData) => {
    dispatch(fetchPreprocessorGroupUsage(rowData?.dmProcessorGroupId));
    setIsDelete(false);
    setDeleteUsage(true);
  };
  useUpdateEffect(() => {
    if (status === true) {
      tableRef.current.onQueryChange();
      setStatus(false);
    }
  }, [status]);

  useEffect(() => {
    if (processorId) {
      dispatch(fetchPrePreprocessorGroupData(type, processorId, processorGroupCode));
    }
  }, [processorId]);

  const handleEdit = (rowData) => {
    dispatch(
      fetchPrePreprocessorGroupData(type, rowData?.dmProcessorGroupId, rowData?.processorGroupCode),
    );
    setShowSearch(true);
  };
  const handleAddProcessorGroup = () => {
    setLoader(true);
    const payload = {
      processorGroupCode: validateId?.current?.processorGroupCode,
      recordCode: managerRecordGroup ? groupCode : recordCode,
      fileType: type,
      moduleType: managerRecordGroup ? 'Record Group' : 'Record',
    };
    httpPost(`data-manager/processor/validate/dmprocessorgroup`, payload)
      .then((response) => {
        if (response?.status === 200 && response?.data?.status !== 400) {
          setTimeout(() => {
            setValidationSuccess(response?.response);
            setValidate(false);
            setProcessorGroupCode(validateId?.current?.processorGroupCode);
            setDmProcessorGroupId(validateId?.current?.dmProcessorGroupId)
            setLoader(false);
          }, 1000);
        } else if (response?.status === 200 && response?.data?.status === 400) {
          setTimeout(() => {
            setValidationError(true);
            setValidate(false);
            setLoader(false);
          }, 1000);
        } else {
          setTimeout(() => {
            setValidationError(false);
            setDeleteErrorMsg(response?.data?.message);
            setValidate(false);
            setStatus(true);
            setProcessorGroupCode('');
            setDmProcessorGroupId(0);
            setLoader(false);
          }, 1000);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <DeleteTableRecordPopup
        open={isDelete}
        dialogClose={handleClose}
        title="Delete Transformation Group"
        value={
          userMetrixDelete ? (
            <UsageMessage value={'Transformation Group'} />
          ) : (
            `Are you sure you want to delete the ${deletedId.current?.processorGroupCode} Transformation Group?`
          )
        }
        // {`Are you sure you want to delete this ${deletedId.current?.processorGroupCode} Transformation Group Name?`}
        buttonCondition={userMetrixDelete}
        handleSubmit={handleDeleteUsage}
      />
      <OverrideRule
        dialogTitle="Delete Transformation Group"
        dialogOpen={isUsage}
        dialogClose={() => setIsUsage((state) => !state)}
        title={`${deletedId.current?.processorGroupCode || ''} - ${
          deletedId.current?.processorType || ''
        } Transformation Group has been used in the following places.`}
        data={preProcessorUsageData?.placeResponse}
        isDataTranformDelete={true}
        isOverRide={false}
      />
      <DialogBox
        open={validationError}
        dialogClose={handleValidationClose}
        title="Warning !"
        maxWidth="sm"
      >
        <ProcessorGroupValidationPopup
          handleValidationClose={handleValidationClose}
          loader={loader}
        />
      </DialogBox>
      <DeleteTableRecordPopup
        open={validate}
        dialogClose={handleValidateClose}
        title="Select Transformation Group"
        value={`Are you sure you want to select ${validateId?.current?.processorGroupCode} Transformation Group Name?`}
        handleSubmit={handleAddProcessorGroup}
      />
      <Grid item xs={12}>
        <div className="custom-table global-field-table custom-toolbar-icons custom-actions-icon new-standard-textfields">
          <GuiTable
            title={''}
            columns={columns}
            icons={tableIcons}
            tableRef={tableRef}
            isLoading={isAddProcessorLoading}
            onSelectionChange={(rows, row) => {
              if (row.tableData.checked) {
                setValidate(true);
                validateId.current = row;
              } else {
                setValidate(false);
                setProcessorGroupCode('');
                setDmProcessorGroupId(0)
              }
            }}
            data={(query) =>
              new Promise((resolve) => {
                const url = `data-manager/processor/find/all/dmprocessorgroup`;
                const bodyObj = {
                  limit: query?.pageSize ? query?.pageSize : null,
                  processorCode: '',
                  processorType: searchData?.processorDescription ?
                    searchData?.processorDescription :
                    '',
                  processorGroupCode: searchData?.groupName ? searchData?.groupName : '',
                  orderDirection: query?.orderDirection ? query?.orderDirection : '',
                  orderBy: query?.orderBy && query?.orderBy?.field ? query?.orderBy?.field : '',
                  createdDate: searchData?.createdDate ?
                    moment(searchData?.createdDate).format('MM/DD/YYYY') :
                    '',
                  type: exportManagerRecord ? 'Export' : 'Import',
                  moduleType: managerRecordGroup ? 'Record Group' : 'Record',
                  page: submit ?
                    1 :
                    arrayLast && query?.page >= 1 ?
                      query.page :
                      arrayLast ?
                        (query.page <= 1 && query.page + 1) || query.page - 1 :
                        query.page + 1,
                };
                if (!searchData) {
                  resolve({
                    data: [],
                    page: 0,
                    totalCount: 0,
                  });
                } else {
                  httpPaginationPost(url, bodyObj)
                    .then((response) => {
                      if (response?.status === 200) {
                        const data = response.data.response.resultObject;
                        const newData =
                          data?.length > 0 ?
                            data?.map((el) => {
                              if (el?.processorGroupCode === processorGroupCode) {
                                setProcessorId(el.dmProcessorGroupId);
                                return {
                                  ...el,
                                  tableData: {...el.tableData, checked: true},
                                };
                              } else {
                                return {
                                  ...el,
                                };
                              }
                            }) :
                            [];
                        resolve({
                          data: processorGroupCode ? newData : data.length > 0 ? data : [],
                          page: response.data.response.page - 1,
                          totalCount: response.data.response.count,
                        });
                        setArrayLast(data.length === 1);
                        setSubmit(false);
                      } else {
                        resolve({
                          data: [],
                          page: 0,
                          totalCount: 5,
                        });
                        dispatch({
                          type: 'FETCH_ERROR',
                          payload: response && response.message ? response.message : null,
                        });
                      }
                    })
                    .catch((response) => {
                      resolve({
                        data: [],
                        page: 0,
                        totalCount: 5,
                      });
                      dispatch({
                        type: 'FETCH_ERROR',
                        payload: response && response.message ? response.message : null,
                      });
                    });
                }
              })
            }
            options={{
              search: false,
              pageSize: rows,
              selection: true,
              toolbar: !processorGroupCode,
              selectionProps: (rowData) => ({
                disabled: !rowData.tableData.checked && processorGroupCode,
              }),
              toolbarButtonAlignment: 'left',
              showSelectAllCheckbox: false,
              emptyRowsWhenPaging: false,
              showTextRowsSelected: false,
              headerStyle: {
                fontWeight: 'bold',
              },
            }}
            components={{
              Pagination: (props) => (
                <div className="global-field-table-footer new-standard-textfields">
                  <TablePagination
                    {...props}
                    SelectProps={{
                      inputProps: {'aria-label': 'Rows per screen'},
                    }}
                    labelRowsPerPage={'Rows per screen:'}
                    rowsPerPageOptions={tablePageRows}
                    onChangeRowsPerPage={(event) => {
                      props.onChangeRowsPerPage(event);
                      setRows(event.target.value);
                    }}
                  />
                </div>
              ),
            }}
            actions={[
              {
                icon: () => (
                  <>
                    <Button
                      type="button"
                      variant="outlined"
                      className={`search-btn`}
                      startIcon={<AddIcon />}
                    >
                      Add Transformation Group
                    </Button>
                  </>
                ),
                isFreeAction: true,
                onClick: () => {
                  setShowSearch(true);
                  dispatch(resetAddPreprocessorGroup());
                },
              },
              {
                icon: () => (
                  <>
                    <EditOutlinedIcon />
                  </>
                ),
                tooltip: 'Edit',
                position: 'row',
                onClick: (event, rowData) => {
                  handleEdit(rowData);
                },
              },
              {
                icon: () => (
                  <>
                    <DataUsageIcon />
                  </>
                ),
                tooltip: 'Usage',
                position: 'row',
                onClick: (event, rowData) => {
                  handleUsage(rowData);
                },
              },
              {
                icon: () => (
                  <>
                    <DeleteOutlineOutlinedIcon />
                  </>
                ),
                tooltip: 'Delete',
                position: 'row',
                disabled: editExisting && !dmTempRecordAccess?.edit,
                onClick: (event, rowData) => {
                  deletedId.current = rowData;
                  setIsDelete(true);
                  handleDelete(rowData);
                },
              },
            ]}
          />
        </div>
      </Grid>
      {loader && <PageLoader />}
      {deleteErrorMsg && <ErrorSnackbar errorMsg={deleteErrorMsg} />}
      {(tstmsg || validationSuccess) && (
        <SuccessSnackbar successMsg={tstmsg || validationSuccess} />
      )}
      {customError && <WarningSnackbar errorMsg={'This Transformation Group is not being used anywhere'} />}
    </>
  );
}

export default ProcessorsGroupTable;
